<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="academicYear" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                :validate-error="errors[0]"
                                v-model="formData.academic_year">
                            </academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('level')">
                        <ValidationProvider name="level" rules="required" v-slot="{ errors }">
                            <ParameterSelectbox code="tuition_levels" v-model="formData.level" :state="errors[0] ? false : null"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('fee')">
                        <ValidationProvider name="fee" rules="required" v-slot="{ errors }">
                            <ParameterSelectbox code="tuition_fees" v-model="formData.fee" :state="errors[0] ? false : null"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>

                <b-col cols="12" v-if="formData.fee === 'housing'" class="mb-3">
                    <div class="p-3 border rounded bg-light">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <h6 class="m-0 font-weight-bold text-primary">Housing Options (Rooms)</h6>
                            <b-button size="sm" variant="success" @click="addOption">
                                <i class="fa fa-plus"></i> Add Room
                            </b-button>
                        </div>

                        <div v-for="(option, index) in formData.options" :key="index" class="mb-2">
                            <b-row>
                                <b-col cols="7">
                                    <ValidationProvider
                                        :name="'Room Name ' + (index+1)"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            v-model="option.text"
                                            placeholder="Room Name (e.g. Single Room)"
                                            :state="errors[0] ? false : null"
                                        ></b-form-input>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="4">
                                    <ValidationProvider
                                        :name="'Room Price ' + (index+1)"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-form-input
                                            type="number"
                                            v-model="option.value"
                                            placeholder="Price"
                                            :state="errors[0] ? false : null"
                                        ></b-form-input>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="1" class="pl-0">
                                    <b-button variant="danger" size="sm" @click="removeOption(index)" v-if="formData.options.length > 1">
                                        <i class="ri-delete-bin-7-line"></i>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                        <small class="text-muted" v-if="(!formData.options || formData.options.length === 0)">
                            Please add at least one room option.
                        </small>
                    </div>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="price" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('price2')">
                            <b-form-input type="number" v-check-min-max-value min="0"  v-model="formData.price">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('per')">
                        <ValidationProvider name="per" rules="required" v-slot="{ errors }">
                            <ParameterSelectbox code="tuition_pers" v-model="formData.per" :state="errors[0] ? false : null"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="updateForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>

import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";


// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
import TuitionCalculatorServices from "@/services/TuitionCalculatorServices";

export default {
    components: {
        AcademicYearsSelectbox,
        ParameterSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                academic_year:null,
                level:null,
                fee:null,
                price:null,
                per:null,
                options: [] // Eklendi
            },
            coordinatorValue: {},
            formLoading: false,
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        },
        'formData.fee'(newVal) {
            if (newVal === 'housing') {
                if (!this.formData.options || this.formData.options.length === 0) {

                    if(!this.formData.options) this.$set(this.formData, 'options', []);
                    if(this.formData.options.length === 0) this.formData.options.push({ text: '', value: '' });
                }
            }
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        addOption() {
            if(!this.formData.options) this.formData.options = [];
            this.formData.options.push({ text: '', value: '' });
        },
        removeOption(index) {
            this.formData.options.splice(index, 1);
        },
        get(id) {
            TuitionCalculatorServices.show(id)
                .then(response => {
                    let data = response.data.data;
                    this.formData = {
                        academic_year:data.academic_year,
                        level:data.level,
                        fee:data.fee,
                        price:data.price,
                        per:data.per,
                        options: data.options ? data.options : []
                    }
                })
                .catch(e => {
                    this.showErrors(e)
                })
        },

        async updateForm() {
            if (this.checkPermission('calculatorfee_update')) {
                const isValid = await this.$refs.formModalValidate.validate();

                if (this.formData.fee === 'housing' && (!this.formData.options || this.formData.options.length === 0)) {
                    this.$toast.error('Please add at least one housing option.');
                    return;
                }

                if (isValid && this.formId) {
                    this.formLoading = true;
                    TuitionCalculatorServices.update(this.formId, this.formData)
                        .then(response => {
                            this.$emit('updateFormSuccess', true);
                            this.$toast.success(this.$t('api.' + response.data.message));
                        })
                        .catch(e => {
                            this.showErrors(e, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>
